<template>   
  <div class="form-group">
    <label>{{ label }}</label>
    <numeric-input 
      class="form-control"
      v-bind:currency="currencySymbol"
      v-bind:separator="separator"
      v-bind:value="value"
      v-on:input="$emit('update:value', $event)"
    ></numeric-input>
  </div>
</template>


<script>
import VueNumeric from 'vue-numeric';
import {currencySymbol}
  from '../../filters/index.js';

export default {
  props: ['value', 'label', 'name', 'currency'],
  components: {
    'numeric-input': VueNumeric
  },
  computed: {
    currencySymbol: function () {
        return currencySymbol[this.currency];
    },
    separator: function () {
        if (this.currency === 'USD') {
            return ',';
        }
        return 'space';
    }
  }
};
</script>